export default __webpack_public_path__ + "media/music/6f71bbeb821fecd6523efa2cb1592f76.mp3";